import React from 'react'
import '../assets/styles/palmares23.css'
import prix1 from '../assets/images/CP_palmares_Gerardmer_20231024_2.jpg'
import prix2 from '../assets/images/CP_palmares_Gerardmer_20231024_3.jpg'
import prix3 from '../assets/images/CP_palmares_Gerardmer_20231024_4.jpg'
import prix4 from '../assets/images/CP_palmares_Gerardmer_20231024_5.jpg'
import prix5 from '../assets/images/CP_palmares_Gerardmer_20231024_6.jpg'
import prix6 from '../assets/images/CP_palmares_Gerardmer_20231024_7.jpg'
import prix7 from '../assets/images/CP_palmares_Gerardmer_20231024_8.jpg'
import prix8 from '../assets/images/CP_palmares_Gerardmer_20231024_9.jpg'
import { Link } from 'react-router-dom'

function Palmares23() {
  return (
    <div>
        <div className="palmares23">
            <img src={prix1} alt="prix gerardmer" />
            <img src={prix2} alt="prix gerardmer" />
            <img src={prix3} alt="prix gerardmer" />
            <img src={prix4} alt="prix gerardmer" />
            <img src={prix5} alt="prix gerardmer" />
            <img src={prix6} alt="prix gerardmer" />
            <img src={prix7} alt="prix gerardmer" />
            <img src={prix8} alt="prix gerardmer" />
        </div>
        <div className="buttonRetour">
<Link to='/palmares'><button style={{margin: "20px 0px", padding: "10px", width: "200px", backgroundColor:"red", border: "none", borderRadius: "10px"}}>RETOUR ACCUEIL</button></Link>
          </div>
    </div>
    
  )
}

export default Palmares23